// extracted by mini-css-extract-plugin
module.exports = {"content":"landing_content__29ada","text":"landing_text__2P2-3","media":"landing_media__2N4P_","picture":"landing_picture__19ntM"};